import _ from 'lodash'
import React from 'react'
import getSymbolFromCurrency from 'currency-symbol-map'
import './style.css'


class PopupPlan extends React.Component {
  render() {
    var p = this.props.plan
    var selected = this.props.selected

    var pd = p.planDetails[0]
    return (
      <div
        className={ `popup-plan ${ selected ? 'selected site-border-color': '' }` }
        onClick={ _ => { if (!selected) this.props.onClick() } }>
        <div className="upper-section">
          <div className="title">{ p.name }</div>
          <div className="desc1">{ pd.featurePlanIdentifier }</div>
          <div className="desc2">
            { getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}{ pd.recurringPaymentAmount }
          </div>
          <div className="points">
            { _.map( pd.featureDetails, (fd, i) => (
              <div className="point site-color-before" key={i}>
                { fd.textToDisplay }
              </div>
            )) }
          </div>
        </div>
        <div
          className={ 'button site-background-color' + (!selected ? ' inactive' : '') }
          onClick={ _ => { if (selected) this.props.onClick() }} >
          { pd.callToAction || this.props.buttonText || 'Start Your Free Trial' }
        </div>
      </div>
    )
  }


}
export default PopupPlan;
